"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorInputState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const bearing_input_state_1 = require("./bearing.input.state");
const distance_input_state_1 = require("./distance.input.state");
const input_state_1 = require("./input.state");
class VectorInputState extends input_state_1.InputState {
    get value() {
        if (this.distance.value == null && this.bearing.value == null) {
            return null;
        }
        return {
            bearing: this.bearing.value,
            distance: this.distance.value,
            pitch: this.pitch,
        };
    }
    static equal(value1, value2) {
        if (value1 === value2) {
            return true;
        }
        if (value1 == null || value2 == null) {
            return false;
        }
        return (distance_input_state_1.DistanceInputState.equal(value1.distance, value2.distance) &&
            bearing_input_state_1.BearingInputState.equal(value1.bearing, value2.bearing) &&
            value1.pitch === value2.pitch);
    }
    constructor(label) {
        super(label);
        this.pitch = null;
        this.isLabelShown = false;
        this.distance = new distance_input_state_1.DistanceInputState('Distance');
        this.bearing = new bearing_input_state_1.BearingInputState('Bearing');
    }
    setValue(val) {
        if (val == null) {
            this.distance.setValue(null);
            this.bearing.setValue(null);
            this.pitch = null;
            this.setError(null);
            return;
        }
        this.distance.setValue(val.distance);
        this.bearing.setValue(val.bearing);
        this.pitch = val.pitch;
        if (val.distance == null && val.bearing == null) {
            this.setError(null);
        }
        else if (val.distance == null) {
            this.setError(i18n_1.T.DISTANCE_MISSING);
        }
        else if (val.bearing == null) {
            this.setError(i18n_1.T.BEARING_MISSING);
        }
        else {
            this.setError(null);
        }
    }
    hasError() {
        return super.hasError() || this.distance.hasError() || this.bearing.hasError();
    }
    get error() {
        // Don't show an error message if one is already being shown
        if (this.distance.hasError() || this.bearing.hasError()) {
            return null;
        }
        if (this.distance.value != null && this.bearing.value == null) {
            return i18n_1.T.BEARING_MISSING;
        }
        if (this.distance.value == null && this.bearing.value != null) {
            return i18n_1.T.DISTANCE_MISSING;
        }
        return this._error;
    }
    set error(msg) {
        this._error = msg || '';
    }
    destroy() {
        super.destroy();
        this.distance.destroy();
    }
}
exports.VectorInputState = VectorInputState;
tslib_1.__decorate([
    mobx_1.computed
], VectorInputState.prototype, "value", null);
tslib_1.__decorate([
    mobx_1.action
], VectorInputState.prototype, "setValue", null);
tslib_1.__decorate([
    mobx_1.computed
], VectorInputState.prototype, "error", null);
//# sourceMappingURL=vector.input.state.js.map